import { validateEmail } from '../';
import { fromServerErrors } from '../errors';
import { hasInvisibleChars } from '../unicode_chars';

// const TYPE_TRAVELLER = 0;
const TYPE_STAFF = 1;

const MIN_PASSWORD_LENGTH = 8;

export const validateUser = (user, serverErrors) => {
    const errors = { ...fromServerErrors(serverErrors) };
    const isCreate = !user.id;
    let canSave = !!errors;
    if (hasInvisibleChars(user.email)) {
        canSave = false;
        errors.email = { error: true, helperText: 'Please do not use hidden unicode characters in this field' };
    }


    if (user.type === TYPE_STAFF || user.is_tour_operator_staff) {
        if (isCreate && user.password1 && user.password2 && user.password1.length > 0 && user.password2.length > 0 && user.password1 !== user.password2) {
            console.log('validateUser: password length mismatch', user, errors, serverErrors);
            errors.password2 = { error: true, helperText: 'Passwords do not match' };
            canSave = false;
        }
        if (isCreate && user.has_admin_access && (!user.password1 || user.password1.length < MIN_PASSWORD_LENGTH)) {
            console.log('validateUser: password length', user, errors, serverErrors);
            canSave = false;
        }
        if (isCreate && (!user.password1 || (user.password1.length > 0 && user.password1.length < MIN_PASSWORD_LENGTH))) {
            errors.password1 = { error: true, helperText: `Please use passwords at least ${MIN_PASSWORD_LENGTH} characters long` };
        }
    }
    // if (user.first_name.length <= 0) {
    //     if (user._changed && user._changed_first_name) {
    //         errors.first_name = { error: true, helperText: "First name is required"}
    //     }
    //     console.log('validateUser: first name', user, errors, serverErrors);
    //     canSave = false;
    // }
    if (user.email?.length <= 0) {
        canSave = false;
        console.log('validateUser: email', user, errors, serverErrors);
    }

    if (user.email && user.email.length > 0 && !validateEmail(user.email) && user.email_blured) {
        if (user._changed_email) {
            errors.email = { error: true, helperText: 'Please use a valid email address' };
        }
        console.log('validateUser: email invalid', user, errors, serverErrors);
        canSave = false;
    }
    return { canSave, errors };
};
